export const endpoints = {
  yextScanCreate: () => `/scan/create`,
  getYexyScanResult: (id) => `/scan/results/${id}`,
  createReportShortLink: () => `/scan/report`,
  getReportForBusiness: (reportId) => `/scan/report/${reportId}`,
};
